"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeError = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const types_1 = require("../types");
const getSizeError = (minOrderIncrement, minOrderSize, maxMarginRequirement, maxPositionSize, value) => {
    if (!value)
        return undefined;
    if ((0, big_1.default)(value).gt(maxMarginRequirement))
        return types_1.SizeError.OrderAboveUserMax;
    if ((0, big_1.default)(value).lt(minOrderSize))
        return types_1.SizeError.OrderBelowMin;
    if ((0, big_1.default)(value).gt(maxPositionSize))
        return types_1.SizeError.OrderAboveMax;
    if ((0, big_1.default)(value).mod(minOrderIncrement).gt(0))
        return types_1.SizeError.IncrementTooSmall;
    return undefined;
};
exports.getSizeError = getSizeError;
//# sourceMappingURL=sizeErrors.js.map